export const initCommentTextOverride = () => {
  const commentsTime = document.querySelectorAll('.comment-meta a');
  commentsTime?.forEach((el) => {
    el.innerText = el.innerText.replace('at', '');
  });

  const playVideo = document.querySelectorAll(
    '.section-divi .et_pb_video_play',
  );

  if (playVideo) {
    for (let i = 0; i < playVideo.length; i++) {
      playVideo[i].setAttribute('aria-label', 'play video');
    }
  }

  const historyImgAltText = document.querySelectorAll('.ctl-wrapper img');

  if (historyImgAltText) {
    for (let i = 0; i < historyImgAltText.length; i++) {
      historyImgAltText[i].setAttribute('alt', 'History Photo');
    }
  }

  const formLabel = document.querySelector(
    'body .email-signup .email-signup-form .gform-body.gform_body .ginput_container.ginput_container_email input',
  );

  formLabel.setAttribute('aria-label', 'sign up');

  const submitBtn = document.querySelector(
    '.gform-footer #gform_submit_button_1',
  );
  const form = submitBtn.closest('form');

  submitBtn.addEventListener('click', (e) => {
    e.preventDefault();

    submitBtn.disabled = true;

    form.submit();
  });
};
